import * as types from './types';

export default function reducer(state = {}, { type, payload }) {
  switch (type) {
    case types.PAGE_STATE_CACHE_ADD_PAGE_STATE: {
      const { stateName, pageState } = payload;

      return { ...state, [stateName]: pageState };
    }
    case types.PAGE_STATE_CACHE_REMOVE_PAGE_STATE: {
      const copy = { ...state };
      delete copy[payload.stateName];

      return copy;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/pagestatecache/reducer.js